import { render } from "./SwdAdaptiveSpinner.vue?vue&type=template&id=a2c708d4&scoped=true"
import script from "./SwdAdaptiveSpinner.vue?vue&type=script&lang=js"
export * from "./SwdAdaptiveSpinner.vue?vue&type=script&lang=js"

import "./SwdAdaptiveSpinner.vue?vue&type=style&index=0&id=a2c708d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2c708d4"]])

export default __exports__